export const c_alert_GridTemplateAreas = {
  "name": "--pf-c-alert--GridTemplateAreas",
  "value": "\"toggle icon title action\"\n    \". . description description\"\n    \". . actiongroup actiongroup\"",
  "var": "var(--pf-c-alert--GridTemplateAreas)"
};
export default c_alert_GridTemplateAreas;